module.exports = __webpack_public_path__ + "img/czzsm.6a1e3682.png";